import { useRef, useState } from 'react';
import { archetypes } from '../data/archetypes';
import styles from './VoucherPrint.module.css';

export default function VoucherPrint({
  archetypeKey,
  landscapeImageUrl,
  onClose,
  onNeedLandscape,
}) {
  const voucherRef = useRef(null);
  const [showBack, setShowBack] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const archetype = archetypes[archetypeKey] || archetypes.jester;

  // 截取异化信号的前两句话
  const getAlienationShort = () => {
    const sentences = archetype.alienation.split('。');
    return sentences.slice(0, 2).join('。') + '。';
  };

  // 截取疗愈处方的第一句话
  const getVacationShort = () => {
    const sentences = archetype.vacation.split('。');
    return sentences[0] + '。';
  };

  const handlePrint = () => {
    if (!landscapeImageUrl) return;
    setIsPrinting(true);

    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('请允许弹出窗口以进行打印');
      setIsPrinting(false);
      return;
    }

    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>原型宇宙体验券 - ${archetype.name}</title>
        <style>
          @page { size: 220mm 80mm; margin: 0; }
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body {
            font-family: 'FZMoYun', 'Microsoft YaHei', sans-serif;
            background: #fff;
          }
          @font-face {
            font-family: 'FZMoYun';
            src: url('/fonts/FZMoYTJW-R.TTF') format('truetype');
          }
          .voucher {
            width: 220mm;
            height: 80mm;
            position: relative;
            background: #000;
            overflow: hidden;
            page-break-after: always;
          }
          .voucher-front {
            width: 100%;
            height: 100%;
            position: relative;
          }
          /* 左上角 Prototype Universe */
          .prototype-text-img {
            position: absolute;
            top: 12%;
            left: 10%;
            width: 18%;
            height: auto;
            z-index: 10;
          }
          /* 左侧纪念券文字 */
          .vertical-text {
            position: absolute;
            left: 4%;
            top: 48%;
            transform: translateY(-50%);
            writing-mode: vertical-rl;
            font-size: 32px;
            color: #fff;
            letter-spacing: 16px;
            font-family: 'FZMoYun', serif;
            z-index: 10;
          }
          /* 中间风景图 */
          .landscape-wrapper {
            position: absolute;
            left: 10%;
            top: 16%;
            width: 58%;
            height: 72%;
            z-index: 15;
          }
          .landscape-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
          }
          /* 右侧信息区 */
          .info-area {
            position: absolute;
            right: 4%;
            top: 14%;
            width: 24%;
            height: 70%;
            display: flex;
            flex-direction: column;
            z-index: 10;
            font-family: 'FZMoYun', serif;
          }
          .logo-img {
            width: 80%;
            max-width: 150px;
            height: auto;
            margin-bottom: 8px;
          }
          .archetype-row {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 10px;
          }
          .planet-icon {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            border: 1px solid rgba(255,255,255,0.5);
            overflow: hidden;
          }
          .planet-icon img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            filter: grayscale(100%) contrast(1.2);
          }
          .archetype-name {
            font-size: 16px;
            color: #fff;
            font-family: 'FZMoYun', serif;
          }
          .info-block {
            margin-bottom: 8px;
          }
          .info-title {
            font-size: 12px;
            color: ${archetype.color};
            margin-bottom: 3px;
            font-weight: bold;
            font-family: 'FZMoYun', serif;
          }
          .info-text {
            font-size: 10px;
            color: rgba(255,255,255,0.8);
            line-height: 1.5;
            font-family: 'FZMoYun', serif;
          }
          /* 底部装饰 */
          .bottom-decor {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 5;
          }
          .bottom-decor img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: fill;
          }
          .voucher-back { 
            width: 100%; 
            height: 100%; 
            position: relative;
          }
          .voucher-back img { 
            width: 100%; 
            height: 100%; 
            object-fit: fill;
          }
          .print-label {
            display: none;
          }
          @media print {
            body { background: white; margin: 0; padding: 0; }
            .voucher { 
              page-break-after: always;
              margin: 0;
            }
            .voucher:last-of-type {
              page-break-after: auto;
            }
          }
        </style>
      </head>
      <body>
        <div class="voucher">
          <div class="voucher-front">
            <img src="/images/voucher-prototype-text.png" alt="" class="prototype-text-img" />
            <span class="vertical-text">纪念券</span>
            <div class="landscape-wrapper">
              <img src="${landscapeImageUrl}" alt="星球风景" class="landscape-image" />
            </div>
            <div class="info-area">
              <img src="/images/voucher-logo.png" alt="原型宇宙" class="logo-img" />
              <div class="archetype-row">
                <div class="planet-icon">
                  <img src="${archetype.planetImg}" alt="" />
                </div>
                <span class="archetype-name">${archetype.name} · ${archetype.planet}</span>
              </div>
              <div class="info-block">
                <div class="info-title">异化信号</div>
                <div class="info-text">${getAlienationShort()}</div>
              </div>
              <div class="info-block">
                <div class="info-title">疗愈处方</div>
                <div class="info-text">${getVacationShort()}</div>
              </div>
            </div>
            <div class="bottom-decor">
              <img src="/images/voucher-bottom-decor.png" alt="" />
            </div>
          </div>
        </div>
        <div class="print-label">▲ 正面</div>
        
        <div class="voucher">
          <div class="voucher-back">
            <img src="/images/tiyanbeimian.png" alt="背面" />
          </div>
        </div>
        <div class="print-label">▲ 背面</div>
        
        <script>
          window.onload = function() {
            setTimeout(function() { window.print(); }, 1000);
          };
        <\/script>
      </body>
      </html>
    `;

    printWindow.document.write(printContent);
    printWindow.document.close();
    setIsPrinting(false);
  };

  // 如果没有风景图，显示提示界面
  if (!landscapeImageUrl) {
    return (
      <div className={styles.overlay} onClick={onClose}>
        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
          <button className={styles.closeBtn} onClick={onClose}>×</button>
          <div className={styles.noImagePrompt}>
            <div className={styles.promptIcon}>✧</div>
            <h2 className={styles.promptTitle}>请先生成星球风景</h2>
            <p className={styles.promptText}>
              体验券需要使用 AI 生成的星球风景图作为封面，<br />
              请先前往「星球风景」功能生成你的专属风景图。
            </p>
            <button className={styles.goLandscapeBtn} onClick={onNeedLandscape}>
              ✧ 前往生成星球风景
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={onClose}>×</button>

        <h2 className={styles.title}>体验券预览</h2>

        <div className={styles.toggleBtns}>
          <button
            className={`${styles.toggleBtn} ${!showBack ? styles.active : ''}`}
            onClick={() => setShowBack(false)}
          >
            正面
          </button>
          <button
            className={`${styles.toggleBtn} ${showBack ? styles.active : ''}`}
            onClick={() => setShowBack(true)}
          >
            背面
          </button>
        </div>

        <div className={styles.voucherPreview} ref={voucherRef}>
          {!showBack ? (
            <div className={styles.voucherFront}>
              {/* 左上角 Prototype Universe */}
              <img 
                src="/images/voucher-prototype-text.png" 
                alt="" 
                className={styles.prototypeTextImg} 
              />
              
              {/* 左侧纪念券文字 */}
              <span className={styles.verticalText}>纪念券</span>

              {/* 中间风景图 */}
              <div className={styles.landscapeWrapper}>
                <img
                  src={landscapeImageUrl}
                  alt="星球风景"
                  className={styles.landscapeImage}
                />
              </div>

              {/* 右侧信息区 */}
              <div className={styles.infoArea}>
                <img 
                  src="/images/voucher-logo.png" 
                  alt="原型宇宙" 
                  className={styles.logoImg} 
                />

                <div className={styles.archetypeRow}>
                  <div className={styles.planetIcon}>
                    <img src={archetype.planetImg} alt="" />
                  </div>
                  <span className={styles.archetypeName}>
                    {archetype.name} · {archetype.planet}
                  </span>
                </div>

                <div className={styles.infoBlock}>
                  <div className={styles.infoTitle} style={{ color: archetype.color }}>
                    异化信号
                  </div>
                  <div className={styles.infoText}>{getAlienationShort()}</div>
                </div>

                <div className={styles.infoBlock}>
                  <div className={styles.infoTitle} style={{ color: archetype.color }}>
                    疗愈处方
                  </div>
                  <div className={styles.infoText}>{getVacationShort()}</div>
                </div>
              </div>

              {/* 底部装饰 */}
              <div className={styles.bottomDecor}>
                <img src="/images/voucher-bottom-decor.png" alt="" />
              </div>
            </div>
          ) : (
            <div className={styles.voucherBack}>
              <img src="/images/tiyanbeimian.png" alt="背面" className={styles.backImage} />
            </div>
          )}
        </div>

        <button className={styles.printBtn} onClick={handlePrint} disabled={isPrinting}>
          {isPrinting ? '准备打印中...' : '🖨️ 打印体验券'}
        </button>

        <p className={styles.hint}>点击打印后会打开新窗口，包含正反两面</p>
      </div>
    </div>
  );
}
